<template>
  <div class="page-wrapper">
    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 col-lg-5 align-self-center col-12">
          <ul class="breadcrumb mb-2 list-style-none" style="margin-top: 1rem">
            <li
              class="h6 font-16 mylink"
              :class="{ active: $route.name === 'Alarms' }"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="/alarms/list">
                {{ $t('alarms') }}
              </router-link>
            </li>
            <li
              class="h6 font-16 mylink"
              :class="{ active: $route.name === 'TriggeredAlarms' }"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="/alarms/triggered-alarms" exact>
                {{ $t('triggered_alarms') }}
              </router-link>
            </li>
          </ul>
        </div>

        <div
          class="col-md-7 col-lg-7 align-self-center col-12 justify-content-end"
          style="display: flex; margin-left: auto; gap: 0.8rem"
        >
          <!-- Right-aligned actions similar to DeviceSession -->
          <router-link v-if="showAddButton" to="/alarms/add-alarm-page">
            <button class="btn btn-primary">
              {{ $t('add_alm') }}
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <router-view />

    <footer class="footer text-center">
      ©{{ new Date().getFullYear() }} {{ $t('all-rights') }}
    </footer>
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AlarmTabs',
  computed: {
    ...mapGetters(['canPerformAction']),
    showAddButton() {
      return (
        this.$route.name === 'Alarms' &&
        this.canPerformAction('alarms', 'addOrEdit')
      );
    },
  },
};
</script>

<style scoped>
.mylink {
  color: #5e6a79 !important;
  font-size: 14px !important;
}
.mylink:hover,
.router-link-exact-active.router-link-active,
.active {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
}
</style>

<i18n>
{
  "en": {
    "alarms": "Alarms",
    "triggered_alarms": "Triggered Alarms",
    "add_alm": "Add Alarm",
    "all-rights": "All Rights Reserved"
  },
  "fr": {
    "alarms": "Alarmes",
    "triggered_alarms": "Alarmes Déclenchées",
    "add_alm": "Ajouter une alarme",
    "all-rights": "Tous droits réservés"
  }
}
</i18n>
